export default {"src":"https://cloudflare.edhrec.com/_next/static/media/enchantment.e0b7253f.svg","height":470,"width":600,"blurWidth":0,"blurHeight":0};